<div
  class="overlay"
  (click)="dismissAll()"
  [@fadeInOut]
  *ngIf="toasts.length > 0"
>
  <div class="toasted-wrap">
    <div
      class="toasted d-flex flex-row gap"
      (click)="dismiss(toast)"
      *ngFor="let toast of toasts"
    >
      <img [src]="toast.image" />
      <div class="d-flex flex-column text-white">
        <h6 class="">{{ toast.title | titleExtractor }}</h6>

        <div class="properties" *ngFor="let property of toast.properties">
          {{ property.value }}
        </div>
        <div class="properties" *ngIf="toast.title.split('|').length == 5">
          {{ toast.title.split("|")[3] }}
        </div>
        <div class="properties" *ngIf="toast.title.split('|').length == 5">
          {{ toast.title.split("|")[4] }}
        </div>
        <div class="properties" *ngIf="toast.title.split('|').length == 5">
          {{ toast.title.split("|")[5] }}
        </div>
        <div class="d-flex d-sm-none mt-2 text-white">
          {{ toast.price | currency }}
        </div>
      </div>
      <div class="d-sm-flex d-none text-white ms-auto">
        {{ toast.price | currency }}
      </div>
    </div>
  </div>
</div>
